import { useTranslation } from 'react-i18next';
import type { WorkforceVM } from '../panels/operationsPanels';
import styles from './rightRail.module.css';

export function WorkforceSummary({ data }: { data: WorkforceVM }) {
  const { t } = useTranslation();
  return (
    <section className={styles.panel}>
      <h3 className={styles.panelTitle}>{t('activities.panel.workforce.title')}</h3>
      <div className={styles.wfRow}>
        <div className={styles.wfStat}>
          <span className={styles.wfValue}>{data.onSite}</span>
          <span className={styles.wfLabel}>{t('activities.panel.workforce.onSite')}</span>
        </div>
        <div className={styles.wfStat}>
          <span className={`${styles.wfValue} ${styles.wfMissing}`}>{data.missing}</span>
          <span className={styles.wfLabel}>{t('activities.panel.workforce.missing')}</span>
        </div>
        <div className={styles.wfStat}>
          <span className={`${styles.wfValue} ${styles.wfAttendance}`}>{data.attendancePct}%</span>
          <span className={styles.wfLabel}>{t('activities.panel.workforce.attendance')}</span>
        </div>
      </div>
    </section>
  );
}
